import { IconMessageChat, IconTask } from "../../assets/svg";
import { useNavigate } from "react-router-dom";

import {
  Container,
  Content,
  Header,
  Footer,
  ContentUser,
  Description,
} from "./styles";
import { ITask } from "../../modules/tasks/interface";
import { StatusTask } from "../../modules/tasks/enum";
import { ButtonHTMLAttributes, HtmlHTMLAttributes } from "react";
import { useTranslate } from "../../hooks/useTranslate";

type ContainerTypes =
  | ButtonHTMLAttributes<HTMLButtonElement>
  | HtmlHTMLAttributes<HTMLDivElement>;

type Props = {
  as?: React.ElementType;
  url?: string;
} & ContainerTypes &
  ITask;

const CardTask = ({
  status,
  creatorName,
  photo,
  description,
  taskCreationDate,
  url,
  ...props
}: Props) => {
  const { translate } = useTranslate();
  const navigate = useNavigate();

  const redirectUser = () => {
    url && navigate(url);
  };

  return (
    <Container {...props} onClick={redirectUser}>
      <Header>
        <IconTask />
        <p>
          {status === StatusTask.FINISHED
            ? translate("tasks.label_finished_task")
            : translate("tasks.label_new_task")}
        </p>
      </Header>
      <Content>
        <img src={photo} alt={description} />
        <Description>
          <p>{description}</p>
          <span>
            {translate("tasks.created")} {taskCreationDate}
          </span>
        </Description>
      </Content>
      <Footer>
        <ContentUser>
          <p>{translate("global.by")} </p>{" "}
          <span>{creatorName || translate("global.uninformed")}</span>
        </ContentUser>
        <IconMessageChat />
      </Footer>
    </Container>
  );
};

export { CardTask };
